import { PropsWithChildren } from "react";
import styled from "styled-components";
import { semanticRed02 } from "../../styles/tokens";
import { NeedsAttentionIcon } from "./icons/needs-attention-icon/NeedsAttentionIcon";

// TEXT

// STYLES
export const Container = styled.div`
  display: flex;
  padding: 1.5rem;
  align-items: flex-start;
  gap: 1rem;
  background-color: ${semanticRed02};
`;

export const Icon = styled(NeedsAttentionIcon)`
  align-self: center;
`;

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-self: center;
`;

// DATA

// TYPES
export interface Props extends PropsWithChildren {
  title?: string;
  message?: string;
  dismissible?: boolean;
}

// CONSTANTS

// FUNCTIONS

// ASSETS
